import { elementOpen, elementVoid, elementClose, } from 'incremental-dom';
var linkedinIcon = function () {
    var paths = [
        "M256,0C114.6,0,0,114.6,0,256S114.6,512,256,512,512,397.4,512,256,397.4,0,256,0Zm0,496C123.5,496,16,388.5,16,256S123.5,16,256,16,496,123.5,496,256,388.6,496,256,496Z",
        "M375.5,204.4c-12.6-12.9-30.5-19.7-51.7-19.7-20.6,0-35.3,7.8-45,15.8V198a8,8,0,0,0-8-8H218.6a8,8,0,0,0-8,8V374a8,8,0,0,0,8,8h52.2a8,8,0,0,0,8-8V281.6c0-20.9,8.5-31.5,25.2-31.5,5.9,0,21.6,0,21.6,31.5V374a8,8,0,0,0,8,8h54.2a8,8,0,0,0,8-8V262.6C395.8,238.1,388.8,217.9,375.5,204.4ZM379.8,366H341.6V281.6c0-41.3-23.6-47.5-37.6-47.5-25.8,0-41.2,17.7-41.2,47.5V366H226.6V206h36.2v15.7a8,8,0,0,0,15,3.8c.6-1,14.2-24.9,46-24.9,35.6,0,56,22.6,56,61.9V366Z",
        "M183.7,190H129.2a8,8,0,0,0-8,8V374a8,8,0,0,0,8,8h54.5a8,8,0,0,0,8-8V198A8,8,0,0,0,183.7,190Zm-8,176H137.2V206h38.5Z",
        "M156.2,102.1a40.45,40.45,0,1,0,40.2,40.5A40.4,40.4,0,0,0,156.2,102.1Zm0,64.9a24.45,24.45,0,1,1,24.2-24.4A24.39,24.39,0,0,1,156.2,167Z"
    ];
    elementOpen('svg', null, null, 'class', 'linkedin-icon contact-icon', 'viewBox', '0 0 512 512');
    paths.map(function (p, i) {
        elementVoid('path', "linkediniconpath-" + i, ['d', p]);
    });
    elementClose('svg');
};
export { linkedinIcon };
//# sourceMappingURL=linkedin.js.map